"use strict";

import "./Section.css";
import React from "react";
import classnames from "classnames";
import lang from "vwa/lang";
import Card from "vwa/components/Card";
import Pin from "vwa/components/Pin";

export default class Section extends React.Component {
		
	isDayChanger() {
		const start = this.props.section.start.time;
		const end = this.props.section.end.time;
		
		if (start.getDate() != end.getDate())
			return true;
		else return false;
	}
	
	handleAddressClick(evt, which) {
		evt.stopPropagation();
		this.props.onAddressClick(which);
	}
	
	renderDot() {
		if (this.props.section.active)
			return null;
		
		return (
			<div className="Dot"/>
		);
	}
	
	renderLabel() {
		if (this.props.isFirst) {
			const label = this.props.section.active ?
							this.props.section.start.time.toLocaleDateString() :
							this.props.section.end.time.toLocaleDateString();
			return <label>{label}</label>
		} else if (this.isDayChanger()) {
			return <label>{this.props.section.end.time.toLocaleDateString()}</label>
		} else {
			return null;
		}
	}
	
	render() {
		return (
			<div className={classnames("Section", {"First": this.props.isFirst})}>
				<div>
					{this.renderLabel()}
				</div>
				<div>
					{this.renderDot()}
					{this.props.children}
				</div>
			</div>
		);
	}
	
}

Section.propTypes = {
	section:		React.PropTypes.object,
	isFirst:		React.PropTypes.bool
};

Section.defaultProps = {
	section:		null,
	isFirst:		false
};


// WEBPACK FOOTER //
// ./src/view/VehicleActivityTimeline/Section/Section.jsx